import { render, staticRenderFns } from "./DashboardCalendar.vue?vue&type=template&id=8916350a&scoped=true"
import script from "./DashboardCalendar.vue?vue&type=script&lang=js"
export * from "./DashboardCalendar.vue?vue&type=script&lang=js"
import style0 from "./DashboardCalendar.vue?vue&type=style&index=0&id=8916350a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8916350a",
  null
  
)

export default component.exports